import React, { useEffect, useRef, useState } from 'react'
import { IListProps, TableParams } from './types'
import { Space, Table, TablePaginationConfig, Tag } from 'antd';
import { FilterValue } from 'antd/lib/table/interface';

function List(props: IListProps) {


  const ref = useRef()

  const [tableParams, setTableParams] = useState<TableParams>({
    pagination: {
      defaultCurrent: props.defaultPage || 1,
      pageSizeOptions: [10, 20, 50, 100],
      showSizeChanger: true,
    },
  });

  const handleTableChange = (
    pagination: TablePaginationConfig,
    filters: any,
    sorter: any,
  ) => {
    if(props.onChange) props.onChange(pagination, filters, sorter)
    setTableParams({pagination,});
  }

  return (
    <div style={props.style} className={`list-component ${props.customClass}`}>
      <div className="list-component__container">
        <Table
          rowKey={props.rowKey}
          scroll={props.scroll || {x: '1200'}}
          bordered
          onRow={(record, rowIndex) => ({
            onClick: () => props.onRowClick ? props.onRowClick(record, rowIndex) : {}
          })}
          onChange={handleTableChange}
          columns={props.columns} 
          dataSource={props.rows}
          pagination={props.pagination === false ? props.pagination : tableParams.pagination}
          rowClassName={props.rowClassName}
          rowSelection={props.rowSelection}
        />
      </div>
    </div>
  )
}

export default List